export default __webpack_public_path__ + "static/media/binance-usd.0835de0c.svg";